export default __webpack_public_path__ + "static/media/bond.8ae44fbb.png";